import GenericDB from './generic-db'

export default class UserEcopledgesDB extends GenericDB {
  constructor(userId) {
    super(`users/${userId}/ecopledges`)
  }
  // Here you can extend UserEcopledgesDB with custom methods
}

